export const blockIconsDeviceAir = (
	<span className='material-symbols-outlined'>air</span>
);
